<template>
  <div>
    <select v-model="selectedPrefix">
      <option value="">Search</option>
      <option v-for="prefix in prefixes" :value="prefix" :key="prefix">{{
        prefix
      }}</option>
    </select>
    <ul v-if="filteredItems.length" class="vertical dropdown menu mention--box">
      <li
        v-for="(item, index) in filteredItems"
        :id="`mention-item-${index}`"
        :key="item.key"
        :class="{ active: index === selectedIndex }"
        @click="onListItemSelection(index)"
        @mouseover="onHover(index)"
      >
        <a class="text-truncate">
          <strong>{{ item.label }}</strong> - {{ item.description }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  props: {},
  data() {
    return {
      selectedIndex: 0,
      searchQuery: "",
      selectedPrefix: "",
    };
  },
  computed: {
    ...mapGetters({
        allCannedResponses: "getAllCannedResponses",
    }),
    prefixes() {
      const prefixMap = new Map();
      this.allCannedResponses.forEach((cannedMessage) => {
        const match = cannedMessage.short_code.match(/\((.*?)\)/);
        if (match && match[1]) {
          const prefix = match[1];
          if (!prefixMap.has(prefix)) {
            prefixMap.set(prefix, []);
          }
          prefixMap.get(prefix).push(cannedMessage);
        } else {
          if (!prefixMap.has("etc.")) {
            prefixMap.set("etc.", []);
          }
          prefixMap.get("etc.").push(cannedMessage);
        }
      });

      const prefixes = Array.from(prefixMap.keys());
      prefixes.sort();
      return prefixes;
    },

    items() {
      return this.allCannedResponses.map((cannedMessage) => ({
        label: cannedMessage.short_code,
        key: cannedMessage.short_code,
        description: cannedMessage.content,
      }));
    },
    filteredItems() {
      let filtered = this.allCannedResponses;

      if (this.selectedPrefix && this.selectedPrefix !== "etc.") {
        filtered = filtered.filter((cannedMessage) => {
          const match = cannedMessage.short_code.match(/\((.*?)\)/);
          return match && match[1] === this.selectedPrefix;
        });
      } else if (this.selectedPrefix === "etc.") {
        filtered = filtered.filter((cannedMessage) => {
          const match = cannedMessage.short_code.match(/\((.*?)\)/);
          return !match || !match[1];
        });
      }

      const query = this.searchQuery.toLowerCase();
      filtered = filtered.filter((cannedMessage) => {
        return cannedMessage.content.toLowerCase().includes(query);
      });

      return filtered.map((cannedMessage) => ({
        label: cannedMessage.short_code,
        key: cannedMessage.short_code,
        description: cannedMessage.content,
      }));
    },
  },
  watch: {
    filteredItems() {
      this.selectedIndex = 0;
    },
    items(newItems) {
      if (newItems.length < this.selectedIndex + 1) {
        this.selectedIndex = 0;
      }
    },
  },
  mounted() {
    this.fetchCannedResponses();
    document.addEventListener("keydown", this.keyListener);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.keyListener);
  },
  methods: {
    ...mapActions(['setSelectedCannedMessage']),
    fetchCannedResponses() {
        this.$store.dispatch("getAllCannedResponse");
    },
    handleMentionClick(item = {}) {
      this.$emit("click", item.description);
    },
    onHover(index) {
      this.selectedIndex = index;
    },
    onListItemSelection(index) {
      this.selectedIndex = index;
      this.onMentionSelect();
    },
    onMentionSelect() {
      const selectedMessage = this.filteredItems[this.selectedIndex];
      this.setSelectedCannedMessage(selectedMessage.description);
      this.$emit("mention-select", this.items[this.selectedIndex]);
    },
  },
};
</script>

<style scoped lang="scss">
.mention--box {
  background: var(--white);
  width: 100%;
  max-height: 40vh;
  overflow-y: auto;
  .active a {
    background: var(--w-500);
  }
}
</style>
